import {Role} from "../../interfaces/role.interface";
import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable, of} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {RolesService} from "../roles.service";

export class RolesDataSource implements DataSource<Role> {

  private rolesSubject = new BehaviorSubject<Role[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private countSubject = new BehaviorSubject<number>(0);
  public currentPageCountSubject = new BehaviorSubject<number>(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.countSubject.asObservable();
	public currentPageCount$ = this.currentPageCountSubject.asObservable();

  constructor(private rolesService: RolesService) {}

  connect(collectionViewer: CollectionViewer): Observable<Role[]> {
    return this.rolesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.rolesSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
		this.currentPageCountSubject.complete();
  }

  list(filters = {}, orderBy = '', order = 'asc',
    pageNumber = 0, pageSize = 5) {

    this.loadingSubject.next(true);

    this.rolesService.index(filters, orderBy, order,
    pageNumber, pageSize).pipe(
    catchError(() => of([])),
    finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(response => {
    this.rolesSubject.next(response.data);
    this.countSubject.next(response.total);
    this.currentPageCountSubject.next(response.data.length);
    });
  }

	getList() {
		return this.rolesSubject.value;
	}
}
